import { render, staticRenderFns } from "./NoticiaPage.vue?vue&type=template&id=157bd1ee"
import script from "./NoticiaPage.js?vue&type=script&lang=js&external"
export * from "./NoticiaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports